"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SwitchStatusBatch = void 0;

var _react = _interopRequireDefault(require("react"));

var _antd = require("antd");

var _permissions = require("../../../constants/permissions");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SwitchStatusBatch =
/*#__PURE__*/
function (_React$Component) {
  _inherits(SwitchStatusBatch, _React$Component);

  function SwitchStatusBatch() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, SwitchStatusBatch);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(SwitchStatusBatch)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "disable", function () {
      var _this$props = _this.props,
          changeStatusBatch = _this$props.changeStatusBatch,
          filter = _this$props.filter; // changeStatusBatch(filter, CHANGE_STATUS_OPERATION.DISABLE);
    });

    _defineProperty(_assertThisInitialized(_this), "enable", function () {
      var _this$props2 = _this.props,
          changeStatusBatch = _this$props2.changeStatusBatch,
          filter = _this$props2.filter; // changeStatusBatch(filter, CHANGE_STATUS_OPERATION.ENABLE);
    });

    _defineProperty(_assertThisInitialized(_this), "resetToDefault", function () {
      var _this$props3 = _this.props,
          changeStatusBatch = _this$props3.changeStatusBatch,
          filter = _this$props3.filter; // changeStatusBatch(filter, CHANGE_STATUS_OPERATION.RESET);
    });

    return _this;
  }

  _createClass(SwitchStatusBatch, [{
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          translate = _this$props4.translate,
          isFetching = _this$props4.isFetching;
      return _react["default"].createElement("div", {
        hidden: true,
        style: {
          marginBottom: '15px'
        }
      }, _react["default"].createElement(_antd.Button.Group, null, _react["default"].createElement(_antd.Button, {
        type: "primary",
        disabled: isFetching,
        onClick: this.disable
      }, translate('disableAll')), _react["default"].createElement(_antd.Button, {
        type: "primary",
        disabled: isFetching,
        onClick: this.enable
      }, translate('enableAll')), _react["default"].createElement(_antd.Button, {
        type: "primary",
        disabled: isFetching,
        onClick: this.resetToDefault
      }, translate('resetToDefaultsAll'))));
    }
  }]);

  return SwitchStatusBatch;
}(_react["default"].Component);

exports.SwitchStatusBatch = SwitchStatusBatch;